/*
 * Public API Surface of sales
 */

export * from './lib/sales.service';
export * from './lib/sales.component';
export * from './lib/sales.module';
